import "./styles.scss";

import moment from "moment";
import JoditEditor from "jodit-react";
import { FlagIcon } from "react-flag-kit";
import { useTranslation } from "react-i18next";
import { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Dialog, DialogTitle, DialogActions, DialogContent } from "@material-ui/core";

import {
  getMethodology,
  getAcademicProgress,
  putAcademicProgress,
  postAcademicProgress,
} from "../../../../store/middleware";
import {
  setAcademicProgressEN,
  setAcademicProgressES,
  setAcademicProgressPT,
  setAcademicProgressFR,
} from "../../../../store/slices/content.slice";
import Api from "../../../../services/api";
import { handleSelectColor } from "../../../../utils/utils";
import IconsLingo from "../../../../components/IconsLingo/iconsLingo";
import { decryptIfEncrypted } from "../../../../utils/fieldDecryptor";
import iconEnglishSVG from "../../../../assets/images/icons/icon_english.svg";
import iconSpanishSVG from "../../../../assets/images/icons/icon_spanish.svg";
import { endLoading, initLoading } from "../../../../store/slices/generics.slice";
import iconPortugueseSVG from "../../../../assets/images/icons/icon_portuguese.svg";

const config = {
  readonly: false,
  height: 600,
  nableDragAndDropFileToEditor: true,
  uploader: {
    insertImageAsBase64URI: true,
  },
};

const AcademicProgress = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { user } = useSelector((state) => state.userReducer);
  const { plans } = useSelector((state) => state.studentReducer);
  const { allLingos } = useSelector((state) => state.genericReducer);
  const { methodology, counterMethodology } = useSelector((state) => state.contentReducer);
  const { academicProgressEN, academicProgressES, academicProgressPT, academicProgressFR } = useSelector(
    (state) => state.contentReducer,
  );

  const [newPlans, setNewPlans] = useState([]);
  const [arrayLang, setArrayLang] = useState("");
  const [multiPlans, setMultiPlans] = useState(false);
  const [languagesMulti, setLanguagesMulti] = useState([]);
  const [buttonSelectNivel, setButtonSelectNivel] = useState("A0");
  const [openModalConfimSend, setOpenModalConfimSend] = useState(false);
  const [buttonSelectLanguage, setButtonSelectLanguage] = useState("EN");

  const editorEN = useRef(null);
  const editorES = useRef(null);
  const editorPT = useRef(null);
  const editorFR = useRef(null);

  const language = localStorage.getItem("i18nextLng");
  const isTeacher = user?.role === "teacher";
  const isStudent = user?.role === "student";
  const isCS = user?.role === "customerService";
  const isManager = user?.role === "companyManager";

  const customOrder = [1, 3, 2];
  const sortedItems = allLingos.filter((item) => customOrder.includes(item.id));
  const remainingItems = allLingos.filter((item) => !customOrder.includes(item.id));
  sortedItems.sort((a, b) => customOrder.indexOf(a.id) - customOrder.indexOf(b.id));
  const finalResultLanguage = [...sortedItems, ...remainingItems];

  const getDataAcademic = async (lang = "EN", level = "A0") => {
    dispatch(getAcademicProgress(lang, level));
    dispatch(getMethodology(lang, level));
  };

  const handleAdd = () => {
    try {
      const id = [academicProgressEN.id, academicProgressES.id, academicProgressPT.id, academicProgressFR.id];
      const content = [
        academicProgressEN.content,
        academicProgressES.content,
        academicProgressPT.content,
        academicProgressFR.content,
      ];
      const languageTranslate = [
        buttonSelectLanguage + " - EN",
        buttonSelectLanguage + " - ES",
        buttonSelectLanguage + " - PT",
        buttonSelectLanguage + " - FR",
      ];

      let body = {};

      for (let x = 0; x < 4; x++) {
        body = {
          content: content[x],
          level: buttonSelectNivel,
          textType: "ACADEMICPROGRESS",
          language: buttonSelectLanguage,
          date: moment().format("YYYY-MM-DD"),
          languageTranslate: languageTranslate[x],
        };

        if (id[x]) {
          let data = { ...body, id: id[x] };
          dispatch(putAcademicProgress(data));
        } else {
          dispatch(postAcademicProgress(body));
        }
      }
    } catch (e) {
      console.log(e);
    }
    setTimeout(() => {
      setOpenModalConfimSend(true);
    }, 3000);
  };

  const handleUpdate = (event, type) => {
    try {
      if (type === "EN") dispatch(setAcademicProgressEN({ id: academicProgressEN.id, content: event }));
      if (type === "ES") dispatch(setAcademicProgressES({ id: academicProgressES.id, content: event }));
      if (type === "PT") dispatch(setAcademicProgressPT({ id: academicProgressPT.id, content: event }));
      if (type === "FR") dispatch(setAcademicProgressFR({ id: academicProgressFR.id, content: event }));
    } catch (e) {
      console.log(e);
    }
  };

  const handleSelectNameNivel = (option) => {
    switch (option) {
      case "A0":
        return t("NIVEL_A0");
      case "A1":
        return t("NIVEL_A1");
      case "A2":
        return t("NIVEL_A2");
      case "B1":
        return t("NIVEL_B1");
      case "B2":
        return t("NIVEL_B2");
      case "C1":
        return t("NIVEL_C1");
      case "C2":
        return t("NIVEL_C2");
      case "DM":
        return t("NIVEL_DM");
    }
  };

  const handleCounterInfo = (value) => {
    switch (value) {
      case "Total":
        return methodology?.others ? methodology?.others.totalResults : 0;
      case "Quiz":
        return counterMethodology?.classTypes?.find((item) => item.classType === "Quiz")
          ? counterMethodology?.classTypes?.find((item) => item.classType === "Quiz")?.count
          : 0;
      case "Cycles":
        return counterMethodology?.countCycle ? counterMethodology?.countCycle : 0;
      case "Test":
        return counterMethodology?.classTypes?.find((item) => item.classType === "Test")
          ? counterMethodology?.classTypes?.find((item) => item.classType === "Test")?.count
          : 0;
      case "Exercises":
        return counterMethodology?.classTypes?.find((item) => item.classType === "Exercises")
          ? counterMethodology?.classTypes?.find((item) => item.classType === "Exercises")?.count
          : 0;
      default:
        return 0;
    }
  };

  const renderHtml = () => {
    return (
      <div className="renderHtml">
        <div className={`headerHtml ${handleSelectColor(buttonSelectNivel)}`}>
          <h3>{t("ACADEMIC_PROGRESS")}</h3>
          <div>
            <IconsLingo width="58" height="24" name={"polygon"} fill={handleSelectColor(buttonSelectNivel)} />
          </div>
        </div>
        <div
          className="contentHtml"
          dangerouslySetInnerHTML={{
            __html:
              language === "en"
                ? academicProgressEN?.content
                : language === "es"
                ? academicProgressES?.content
                : language === "pt"
                ? academicProgressPT?.content
                : academicProgressFR?.content,
          }}
        />
      </div>
    );
  };

  const handleOnclickOptions = (value, type) => {
    if (type === "level") {
      setButtonSelectNivel(value);
      getDataAcademic(buttonSelectLanguage, value);
    } else {
      if (multiPlans) {
        let valueFormatted = value === "EN" ? "US" : value === "PT" ? "BR" : value === "ES" ? "ES" : value;
        let level = arrayLang?.find((item) => item.flag === valueFormatted)?.level;

        if (level === "DM") level = "C2";

        setButtonSelectNivel(level !== undefined ? level : "A0");
        getDataAcademic(value, level !== undefined ? level : "A0", 1);
      }

      if (newPlans.length > 1 && !isTeacher) {
        let valueFormatted = value === "EN" ? "US" : value === "PT" ? "BR" : value === "ES" ? "ES" : value;
        let level = arrayLang?.find((item) => item.flag === valueFormatted)?.level;

        if (level === "DM") level = "C2";

        setButtonSelectNivel(level !== undefined ? level : "A0");
        getDataAcademic(value, level !== undefined ? level : "A0", 1);
      }
      setButtonSelectLanguage(value);
      getDataAcademic(value, buttonSelectNivel);
    }
  };

  useEffect(() => {
    if (isStudent) {
      const newPlan = plans?.flatMap((item) =>
        item.studentPlanLanguages.map((lang) => decryptIfEncrypted(lang.lingoLanguage?.language?.name).toUpperCase()),
      );
      const lang =
        newPlan[0] === "ENGLISH" ? "EN" : newPlan[0] === "SPANISH" ? "ES" : newPlan[0] === "PORTUGUESE" ? "PT" : "FR";
      let level = plans[0]?.student?.studentLevelGrades[0]?.level.level
        ? plans[0]?.student?.studentLevelGrades[0]?.level.level
        : "A0";

      setNewPlans(newPlan);

      if (plans[0]?.plan?.multiLingo) {
        let newArrayLang = [];
        plans[0]?.studentPlanLanguages?.map((lang) =>
          plans[0].student?.studentLevelGrades.filter((grade) => {
            if (grade.lingoLanguageId === lang.lingoLanguageId)
              newArrayLang.push({ flag: lang.lingoLanguage.flag, level: grade.level.level });
          }),
        );

        level = newArrayLang?.find((item) => item.flag === "US")?.level;

        let languages = [];
        plans?.map((plan) => {
          plan?.studentPlanLanguages?.map((language) => {
            languages.push(language?.lingoLanguage);
          });
        });

        setMultiPlans(true);
        setArrayLang(newArrayLang);
        setButtonSelectNivel(level);
        setLanguagesMulti(languages);
        setButtonSelectLanguage("EN");
        getDataAcademic("EN", level);
      } else {
        if (newPlan.length > 1) {
          let newArrayLang = [];
          for (let i = 0; i < plans?.length; i++) {
            plans[i]?.studentPlanLanguages?.map((lang) =>
              plans[i].student?.studentLevelGrades.filter((grade) => {
                if (grade.lingoLanguageId === lang.lingoLanguageId)
                  newArrayLang.push({ flag: lang.lingoLanguage.flag, level: grade.level.level });
              }),
            );
          }

          setArrayLang(newArrayLang);
          if (newArrayLang?.find((item) => item.flag === "US")?.flag === "US") {
            setButtonSelectLanguage("EN");
            setButtonSelectNivel(newArrayLang?.find((item) => item.flag === "US")?.level);
            getDataAcademic("EN", newArrayLang?.find((item) => item.flag === "US")?.level);
          } else if (newArrayLang?.find((item) => item.flag === "BR")?.flag === "BR") {
            setButtonSelectLanguage("PT");
            setButtonSelectNivel(newArrayLang?.find((item) => item.flag === "BR")?.level);
            getDataAcademic("PT", newArrayLang?.find((item) => item.flag === "BR")?.level);
          } else {
            setButtonSelectLanguage("ES");
            setButtonSelectNivel(newArrayLang?.find((item) => item.flag === "ES")?.level);
            getDataAcademic("ES", newArrayLang?.find((item) => item.flag === "ES")?.level);
          }
        } else {
          if (level === "DM") level = "C2";
          setButtonSelectLanguage(lang);
          getDataAcademic(lang, level);
          setButtonSelectNivel(level);
        }
      }
    }

    if (isTeacher) {
      dispatch(initLoading());
      Api.get(`teachermanagement/getbyuser/${user?.id}`)
        .then((res) => {
          const plans = res?.data?.result?.items[0]?.teachers[0]?.teacherLanguages
            .filter((teacherLanguage) => teacherLanguage.isNative)
            .map((teacherLanguageFilter) => decryptIfEncrypted(teacherLanguageFilter?.language?.name).toUpperCase());

          const lang =
            plans[0] === "ENGLISH" ? "EN" : plans[0] === "SPANISH" ? "ES" : plans[0] === "PORTUGUESE" ? "PT" : "FR";

          setNewPlans(plans);
          getDataAcademic(lang, "A0");
          setButtonSelectLanguage(lang);
        })
        .catch((err) => console.log("teachermanagement ", err))
        .finally(() => dispatch(endLoading()));
    }

    if (isManager || isCS) {
      getDataAcademic("EN", "A0");
    }
    // eslint-disable-next-line
  }, []);

  return (
    <div className="containerWrapper">
      <div className="cardNivelAcademic">
        <div className="card">
          <span style={{ width: "100%" }} className="title">
            {t("BASIC")}
          </span>
          <div>
            <button
              onClick={() => handleOnclickOptions("A0", "level")}
              className={`circle green_100 ${buttonSelectNivel === "A0" ? "active" : ""}`}
            >
              A0
            </button>
            <button
              onClick={() => handleOnclickOptions("A1", "level")}
              className={`circle green_700 ${buttonSelectNivel === "A1" ? "active" : ""}`}
            >
              A1
            </button>
            <button
              onClick={() => handleOnclickOptions("A2", "level")}
              className={`circle green_400 ${buttonSelectNivel === "A2" ? "active" : ""}`}
            >
              A2
            </button>
          </div>
        </div>
        <div className="card">
          <span style={{ width: "100%" }} className="title">
            {t("LINGO_INTER")}
          </span>
          <div>
            <button
              onClick={() => handleOnclickOptions("B1", "level")}
              className={`circle yellow_100 ${buttonSelectNivel === "B1" ? "active" : ""}`}
            >
              B1
            </button>
            <button
              onClick={() => handleOnclickOptions("B2", "level")}
              className={`circle yellow_700 ${buttonSelectNivel === "B2" ? "active" : ""}`}
            >
              B2
            </button>
          </div>
        </div>
        <div className="card">
          <span style={{ width: "100%" }} className="title">
            {t("LINGO_ADV")}
          </span>
          <div>
            <button
              onClick={() => handleOnclickOptions("C1", "level")}
              className={`circle red_100 ${buttonSelectNivel === "C1" ? "active" : ""}`}
            >
              C1
            </button>
            <button
              onClick={() => handleOnclickOptions("C2", "level")}
              className={`circle red_500 ${buttonSelectNivel === "C2" ? "active" : ""}`}
            >
              C2
            </button>
          </div>
        </div>
      </div>

      <div className="cardInfoNivel">
        <div className="div nivel">
          <label className="title">{t("LEVEL")}</label>
          <div>
            <span className="description gray_500">{buttonSelectNivel}</span>
            <span className="subTitle">{handleSelectNameNivel(buttonSelectNivel)}</span>
          </div>
        </div>
        <div className="div">
          <label className="title">{t("TOTAL_CLASSES")}</label>
          <span className="description">{handleCounterInfo("Total")}</span>
        </div>
        <div className="div">
          <label className="title">{t("TOTAL_QUIZZES")}</label>
          <span className="description">{handleCounterInfo("Quiz")}</span>
        </div>
        <div className="div">
          <label className="title">{t("TOTAL_CYCLES")}</label>
          <span className="description">{handleCounterInfo("Cycles")}</span>
        </div>
        <div className="div">
          <label className="title">{t("FINAL_TEST")}</label>
          <span className="description">{handleCounterInfo("Test")}</span>
        </div>
        {/* <div className="div">
          <label className="title">{t("COMPLEMENTARY_EXERCISES")}</label>
          <span className="description">{handleCounterInfo("Exercises")}</span>
        </div> */}
      </div>

      {(isStudent || isTeacher) && (
        <>
          <div className="selectLanguage">
            {multiPlans ? (
              <div className="language">
                {languagesMulti
                  .filter((item) => item.active)
                  .sort((a, b) => a.id - b.id)
                  .map((item, i) => {
                    let valueFormatted =
                      item.flag === "US" ? "EN" : item.flag === "BR" ? "PT" : item.flag === "ES" ? "ES" : item.flag;

                    return (
                      <div
                        key={i}
                        onClick={() => handleOnclickOptions(valueFormatted, "lang")}
                        className={buttonSelectLanguage === valueFormatted ? "active" : ""}
                      >
                        <FlagIcon size={35} code={item.flag} />
                        <span className="titleLanguage">{t(item.description.toUpperCase())}</span>
                      </div>
                    );
                  })}
              </div>
            ) : (
              <div className="language">
                {newPlans.includes("ENGLISH") && (
                  <div
                    onClick={() => handleOnclickOptions("EN", "lang")}
                    className={buttonSelectLanguage === "EN" ? "active" : ""}
                  >
                    <img src={iconEnglishSVG} />
                    <span className="titleLanguage">{t("BTN_ENGLISH")}</span>
                  </div>
                )}

                {newPlans.includes("SPANISH") && (
                  <div
                    onClick={() => handleOnclickOptions("ES", "lang")}
                    className={buttonSelectLanguage === "ES" ? "active" : ""}
                  >
                    <img src={iconSpanishSVG} />
                    <span className="titleLanguage">{t("BTN_SPANISH")}</span>
                  </div>
                )}

                {newPlans.includes("PORTUGUESE") && (
                  <div
                    onClick={() => handleOnclickOptions("PT", "lang")}
                    className={buttonSelectLanguage === "PT" ? "active" : ""}
                  >
                    <img src={iconPortugueseSVG} />
                    <span className="titleLanguage">{t("BTN_PORTUGUESE")}</span>
                  </div>
                )}
                {newPlans.includes("FRENCH") && (
                  <div
                    onClick={() => handleOnclickOptions("FR", "lang")}
                    className={buttonSelectLanguage === "FR" ? "active" : ""}
                  >
                    <FlagIcon size={35} code={"FR"} />
                    <span className="titleLanguage">{t("FRENCH")}</span>
                  </div>
                )}
              </div>
            )}
          </div>

          {renderHtml()}
        </>
      )}

      {(isManager || isCS) && (
        <>
          <div className="selectLanguage">
            <div className="language">
              {finalResultLanguage?.map((item, index) => {
                let flag = item.flag === "BR" ? "PT" : item.flag === "US" ? "EN" : item.flag;
                return (
                  <div
                    key={index}
                    className={buttonSelectLanguage === flag ? "active" : ""}
                    onClick={() => {
                      setButtonSelectLanguage(flag);
                      getDataAcademic(flag, buttonSelectNivel);
                    }}
                  >
                    <FlagIcon size={35} code={item.flag} />
                    <span className="titleLanguage">{item.description}</span>
                  </div>
                );
              })}
            </div>

            {isManager && (
              <button onClick={handleAdd} className="addContent">
                {t("BTN_SEND")}
              </button>
            )}
          </div>

          <h1 className="titleEditor">{t("BTN_ENGLISH")}</h1>
          <JoditEditor
            ref={editorEN}
            config={config}
            onChange={() => {}}
            className="joditEditor"
            value={academicProgressEN?.content}
            onBlur={(e) => handleUpdate(e, "EN")}
          />

          <h1 className="titleEditor mt-20">{t("BTN_SPANISH")}</h1>
          <JoditEditor
            ref={editorES}
            config={config}
            onChange={() => {}}
            className="joditEditor"
            value={academicProgressES?.content}
            onBlur={(e) => handleUpdate(e, "ES")}
          />

          <h1 className="titleEditor mt-20">{t("BTN_PORTUGUESE")}</h1>
          <JoditEditor
            ref={editorPT}
            config={config}
            onChange={() => {}}
            className="joditEditor"
            value={academicProgressPT.content}
            onBlur={(e) => handleUpdate(e, "PT")}
          />

          <h1 className="titleEditor mt-20">{t("FRENCH")}</h1>
          <JoditEditor
            ref={editorFR}
            config={config}
            onChange={() => {}}
            className="joditEditor"
            value={academicProgressFR?.content}
            onBlur={(e) => handleUpdate(e, "FR")}
          />
        </>
      )}

      <Dialog
        open={openModalConfimSend}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        onClose={() => setOpenModalConfimSend(false)}
      >
        <DialogTitle id="alert-dialog-title">
          <span className="titleModal">{t("TITLE_MODAL_SEND")}</span>
        </DialogTitle>
        <DialogContent>
          <div style={{ width: "100%" }}>
            <p style={{ textAlign: "center" }}>{t("DESCRIPTION_MODAL_SEND_PROGRESS")}</p>
          </div>
        </DialogContent>
        <DialogActions>
          <button
            type="submit"
            className="addContent"
            onClick={() => setOpenModalConfimSend(false)}
            style={{ marginBottom: 10, marginRight: 15, paddingLeft: 20, paddingRight: 20 }}
          >
            {t("BTN_CLOSE")}
          </button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default AcademicProgress;
